import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import useAppRoutes from '@/config/routes';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import useAuth from '@/hooks/useAuth';
import { Suspense } from 'react';
import AppLoading from './components/AppLoading';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error?.status === 401) {
          return false;
        }

        return true;
      },
    },
  },
});

function App() {
  useAuth();
  const routes = useAppRoutes();
  // const router = createBrowserRouter(
  //   routes.map((route) => ({
  //     ...route,
  //     element: route.element,
  //   })));

  const router = createBrowserRouter(routes);

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<AppLoading />}>
        <RouterProvider router={router} />
      </Suspense>

      <ToastContainer stacked />
      {/* <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" /> */}
    </QueryClientProvider>
  );
}

export default App;
